import axios from "./axios";

// "Spominska za davno pokojne": the form and the document go up in one request, the answer is the Stripe address.
const create = async (formData: FormData) => {
  try {
    const response = await axios.post("/past-memorials", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data as { orderId: number; paymentUrl: string };
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || "Plačila trenutno ni mogoče pripraviti. Poskusi znova."
    );
  }
};

export type PastMemorialRow = {
  id: number;
  status: "unpaid" | "pending" | "approved" | "rejected";
  paymentStatus: "pending" | "paid" | "canceled" | "refunded" | null;
  product: string;
  years: number | null;
  name: string;
  sirName: string;
  location: string;
  city: string | null;
  region: string;
  birthDate: string | null;
  birthYear: number | null;
  deathDate: string | null;
  deathYear: number | null;
  ageInYears: number | null;
  picture: string | null;
  relation: string;
  applicantName: string;
  applicantEmail: string | null;
  document: string;
  isPrivate: boolean;
  orderId: number | null;
  paidAt: string | null;
  createdTimestamp: string;
  approvedAt: string | null;
  obituaryId: number | null;
  slugKey: string | null;
};

// Admin: the paid requests whose document has to be checked (and the decided ones).
const adminList = async () => {
  const response = await axios.get("/past-memorials/admin");
  return (response.data?.rows ?? []) as PastMemorialRow[];
};

// Admin: "approved" creates the memory page and e-mails the buyer; "rejected" only closes the request.
const adminSetStatus = async (id: number, status: "approved" | "rejected") => {
  try {
    const response = await axios.patch(`/past-memorials/admin/${id}`, { status });
    return response.data as PastMemorialRow;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "Prišlo je do napake");
  }
};

// Admin: asks Stripe again about a request whose payment is not confirmed yet; if it is paid it is activated.
const adminCheckPayment = async (id: number) => {
  try {
    const response = await axios.post(`/past-memorials/admin/${id}/sync`);
    return response.data as PastMemorialRow;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "Prišlo je do napake");
  }
};

const pastMemorialService = { create, adminList, adminSetStatus, adminCheckPayment };

export default pastMemorialService;
